<template>
  <div class="twoElementsForm">
    <van-form @submit="onSubmit">
      <div class="label">姓名</div>
      <van-field
        v-model="formData.userName"
        name="userName"
        placeholder="请输入真实姓名"
        :rules="[{ required: true, message: '请输入真实姓名' }]"
      />
      <div class="label">身份证号</div>
      <van-field
        v-model="formData.idCardNo"
        name="idCardNo"
        placeholder="请输入身份证号"
        :rules="[
          { required: true, message: '请输入身份证号' },
          {
            validator: validateIdentityNumber,
            message: '请输入正确的身份证号',
          },
        ]"
      />
      <van-button type="primary" block native-type="submit">下一步</van-button>
    </van-form>
  </div>
</template>
<script>
  import { validateIdentityNumber } from '@/utils/validate'

  export default {
    data() {
      return {
        formData: {
          userName: '',
          idCardNo: '',
        },
      }
    },
    methods: {
      validateIdentityNumber,
      onSubmit(values) {
        this.$store.commit('authentication/setInfo', values)
        this.$router.push('/authentication/face/faceFirst')
      },
    },
  }
</script>
<style lang="less" scoped>
  .twoElementsForm {
    padding: 16px;
    .label {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      color: #111a34;
      line-height: 22px;
      margin-bottom: 8px;
    }
    .van-field {
      padding: 13px 0;
      margin-bottom: 16px;
      border-bottom: 1px solid #f5f5f5;
      /deep/ input {
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #111a34;
        line-height: 22px;
      }
    }
  }
</style>
